import React from 'react';
import { InlineAlert } from '@routific/hive';
import { DateRangeValidationError } from '../../shared/DatePickerRange';
import { useTranslation } from 'react-i18next';
import { DownloadCSVAPIError } from './types';
import styled from 'styled-components';
import { DEFAULT_EXPORT_ORDER_LIMIT } from './helpers/utils';

export type DownloadCSVAlertType = DateRangeValidationError | DownloadCSVAPIError;

interface Props {
  alertType: DownloadCSVAlertType
  orderLimit?: number
}

const StyledInlineAlert = styled(InlineAlert)`
  text-align: 'left';
  .ant-alert-content {
    min-height: 0px;
  }
`;

const DownloadCSVAlert: React.FC<Props> = ({ alertType, orderLimit = DEFAULT_EXPORT_ORDER_LIMIT }) => {
  const { t } = useTranslation(['components', 'common']);

  return <StyledInlineAlert
    data-testid="download-csv-alert"
    type="error"
    message={t(`downloadCSVModal.errors.${alertType}`, { limit: orderLimit })}
  />;
};

export default DownloadCSVAlert;
